import { useEffect } from 'react';
import { HeroSection, StatsBand } from '@/components/home/HeroSection';
import { GroupIntro } from '@/components/home/GroupIntro';
import { BrandsGrid } from '@/components/home/CoreSections';
import { WhyEurogulf, FinalCta } from '@/components/home/TrustSectionsV2';
import { Timeline } from '@/components/home/Timeline';

export default function HomePageAr() {
  useEffect(() => { document.title = 'مجموعة يوروجلف للتنقل | نحن ننقلك! | الاسم الأكثر ثقة في التنقل بالإمارات منذ ١٩٧٦'; }, []);

  return (
    <div data-testid="ar-home-page" dir="rtl">
      <HeroSection lang="ar" />
      <StatsBand lang="ar" />
      <GroupIntro lang="ar" />
      <BrandsGrid lang="ar" />
      <Timeline lang="ar" />
      <WhyEurogulf lang="ar" />
      <FinalCta lang="ar" />
    </div>
  );
}
